import { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Avatar, Link, makeStyles } from '@material-ui/core'
import { BsLayoutSidebarInset } from 'react-icons/bs'
import { MdSupportAgent } from 'react-icons/md'

import { Button, Dialog, Flex } from 'app/ui'
import { ChooseLanguage } from './ChooseLanguage'
import { CustomerService } from './CustomerService'

import { useUserStore } from 'app/stores/app/user'
import { assets, urls } from 'app/utils/constants'
import { palette, various } from 'app/utils/theme'

const useStyles = makeStyles((theme) => ({
    root: {
        zIndex: 100,
        padding: `10px ${various.padding}`,
        backgroundColor: palette.primary.main,
        boxShadow: various.boxShadow.component,
        [theme.breakpoints.up('lg')]: {
            padding: '10px 10%',
        },
        [theme.breakpoints.up('xl')]: {
            padding: '10px 20%',
        },
    },

    header: {
        justifyContent: 'space-between',
        width: '100%',
    },

    homepage: {
        cursor: 'pointer',
        display: 'flex',
    },

    logo: {
        width: '50px',
        height: '50px',
    },

    group: {
        display: 'flex',
    },

    avatar: {
        height: '25px',
        width: '25px',
    },

    name: {
        display: 'none',
        paddingLeft: '10px',
        [theme.breakpoints.up('md')]: {
            display: 'unset',
        },
    },
}))

type HeaderProperties = {
    toggleShowSidebar: () => void
}

export const Header = ({
    toggleShowSidebar,
}: Readonly<HeaderProperties>): JSX.Element => {
    const classes = useStyles()
    const history = useHistory()
    const { t } = useTranslation()

    const user = useUserStore((state) => state.user)

    const [wantsCustomerService, setWantsCustomerService] = useState(false)

    return (
        <header className={classes.root}>
            <Flex className={classes.header}>
                <Flex>
                    {/* Homepage button */}
                    <Link
                        className={classes.homepage}
                        variant='button'
                        onClick={() => {
                            history.push(urls.DASHBOARD)
                        }}
                    >
                        <img
                            className={classes.logo}
                            src={assets.ethik.KONSOLE_WHITE}
                            alt='Logo'
                        />
                    </Link>

                    {/* Toggle sidebar */}
                    <Button
                        variant='text'
                        color='secondary'
                        onClick={() => {
                            toggleShowSidebar()
                        }}
                    >
                        <BsLayoutSidebarInset size='1.5rem' />
                    </Button>
                </Flex>

                {/* Settings */}
                <Flex className={classes.group}>
                    {/* Customer service */}
                    <Button
                        variant='outlined'
                        color='secondary'
                        icon={<MdSupportAgent />}
                        onClick={() => {
                            setWantsCustomerService(true)
                        }}
                    >
                        <div className={classes.name}>
                            {t('customerService')}
                        </div>
                    </Button>

                    {/* Dialog customer service */}
                    <Dialog
                        open={wantsCustomerService}
                        onClose={() => {
                            setWantsCustomerService(false)
                        }}
                    >
                        <CustomerService />
                    </Dialog>

                    {/* Language */}
                    <ChooseLanguage />

                    {/* Account */}
                    <Button
                        variant='outlined'
                        color='secondary'
                        icon={<Avatar className={classes.avatar} />}
                        onClick={() => {
                            history.push(urls.ACCOUNT)
                        }}
                    >
                        <div className={classes.name}>{user.first_name}</div>
                    </Button>
                </Flex>
            </Flex>
        </header>
    )
}
